import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import React from 'react';
import { useIntl } from 'react-intl';
import { TeamTableSortMethod } from '../../../Dashboard/DashboardComponents/LighthouseMetrics/helper';

interface LighthouseSortProps {
  sortMethod: TeamTableSortMethod;
  setSortMethod: any;
  sourcePage: string;
}

const Sort: React.FC<LighthouseSortProps> = ({
  sortMethod,
  setSortMethod,
  sourcePage,
}: LighthouseSortProps): React.ReactElement => {
  const intl = useIntl();

  return (
    <Row wrap='down'>
      <Select
        label={intl.formatMessage({
          id: 'cs_perfportal_sort_method',
          defaultMessage: 'Method',
        })}
        value={sortMethod}
        onChange={setSortMethod}
        size='xlarge'
        width='240px'
      >
        <SelectOption
          key={'metric_value'}
          value={TeamTableSortMethod.METRIC_VALUE}
          label={intl.formatMessage({
            id: 'cs_perfportal_sort_metric_by_metric_value',
            defaultMessage: 'Metric Value',
          })}
          data-csa-c-type='select'
          data-csa-c-slot-id='team-table-sortmethod-type-slot'
          data-csa-c-content-id='sort_method_change'
          data-csa-c-tag1={sourcePage}
          data-csa-c-from={TeamTableSortMethod.DIFF_TO_BENCHMARK}
          data-csa-c-to={TeamTableSortMethod.METRIC_VALUE}
        />
        <SelectOption
          key={'diff_to_benchmark'}
          value={TeamTableSortMethod.DIFF_TO_BENCHMARK}
          label={intl.formatMessage({
            id: 'cs_perfportal_sort_metric_by_diff_to_benchmark',
            defaultMessage: 'Difference to Benchmark',
          })}
          data-csa-c-type='select'
          data-csa-c-slot-id='team-table-sortmethod-type-slot'
          data-csa-c-content-id='sort_method_change'
          data-csa-c-tag1={sourcePage}
          data-csa-c-from={TeamTableSortMethod.METRIC_VALUE}
          data-csa-c-to={TeamTableSortMethod.DIFF_TO_BENCHMARK}
        />
      </Select>
    </Row>
  );
};
export default Sort;
